<template>
  <div>
    <Batteries />
  </div>
</template>

<script>
import Batteries from "@/components/Batteries/index.vue";
export default {
  components: {
    Batteries,
  },
};
</script>

<style></style>
